import React from 'react'
import { ConversationMessage } from '../types/conversationHistory'

interface MessageBubbleProps {
  message: ConversationMessage
  isHistorical?: boolean
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isHistorical = false }) => {
  const formatTimestamp = (timestamp: Date) => {
    return new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(timestamp)
  }

  const getBubbleStyle = (type: ConversationMessage['type']) => {
    switch (type) {
      case 'user':
        return {
          backgroundColor: '#dcf8c6',
          marginLeft: 'auto',
          marginRight: '10px',
          color: '#000'
        }
      case 'bot':
        return {
          backgroundColor: '#ffffff',
          marginLeft: '10px',
          marginRight: 'auto',
          color: '#000'
        }
      case 'tool':
        return {
          backgroundColor: '#e3f2fd',
          marginLeft: '50px',
          marginRight: '50px',
          color: '#1565c0',
          borderRadius: '20px',
          fontSize: '0.9em'
        }
      case 'summary':
        return {
          backgroundColor: '#fff3cd',
          marginLeft: '50px',
          marginRight: '50px',
          color: '#856404',
          borderRadius: '20px',
          fontSize: '0.9em'
        }
      case 'system':
        return {
          backgroundColor: '#f3e5f5',
          marginLeft: '50px',
          marginRight: '50px',
          color: '#7b1fa2',
          borderRadius: '20px',
          fontSize: '0.9em'
        }
      default:
        return {
          backgroundColor: '#f0f0f0',
          marginLeft: '10px',
          marginRight: 'auto',
          color: '#000'
        }
    }
  }

  const bubbleStyle = getBubbleStyle(message.type)

  if (message.type === 'tool' || message.type === 'summary' || message.type === 'system') {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        margin: '8px 0',
        opacity: isHistorical ? 0.7 : 1
      }}>
        <div style={{
          ...bubbleStyle,
          padding: '8px 16px',
          maxWidth: '300px',
          wordWrap: 'break-word',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          border: isHistorical ? '1px dashed #ccc' : 'none'
        }}>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
            {message.type === 'tool' ? '🛠️ Tool' : 
             message.type === 'summary' ? '📝 Summary' :
             '⚙️ System'}
          </div>
          <div>{message.content}</div>
          <div style={{
            fontSize: '0.8em',
            color: '#666',
            marginTop: '4px',
            textAlign: 'center'
          }}>
            {formatTimestamp(message.timestamp)}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{
      display: 'flex',
      marginBottom: '8px',
      opacity: isHistorical ? 0.7 : 1
    }}>
      <div style={{
        ...bubbleStyle,
        padding: '8px 12px',
        borderRadius: '18px',
        maxWidth: '70%',
        wordWrap: 'break-word',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        border: isHistorical ? '1px dashed #999' : 'none'
      }}>
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {message.content}
        </div>
        <div style={{
          fontSize: '0.8em',
          color: '#666',
          marginTop: '4px',
          textAlign: message.type === 'user' ? 'right' : 'left'
        }}>
          {formatTimestamp(message.timestamp)}
          {isHistorical && (
            <span style={{ marginLeft: '4px', fontStyle: 'italic' }}>
              (historial)
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
